export default {
  isLoadingDashboardCountries: true,
  globalBenchmarkingId: '',
  loadError: false,
};
